import { createRouter, createWebHistory } from 'vue-router';
// import Cookies from 'js-cookie';
import Login from '@/views/Login.vue';
import MobileNo from '@/views/MobileNo.vue';
import VerifyOtp from '@/views/VerifyOtp.vue';
import store from '@/store'; // Import your Vuex store

// const OnboardingType = () =>
//   import(
//     /* webpackChunkName: "OnboardingType" */ '@/views/OnboardingType.vue'
//   );
const Dashboard = () =>
  import(
    /* webpackChunkName: "Dashboard" */ '@/views/Dashboard.vue'
  );
const Success = () =>
  import(
    /* webpackChunkName: "Success" */ '@/views/Success.vue'
  );
const Failure = () =>
  import(
    /* webpackChunkName: "Failure" */ '@/views/Failure.vue'
  );
// const Tnc = () =>
//   import(
//     /* webpackChunkName: "Tnc" */ '@/views/Tnc.vue'
//   );
// const ServiceabilityCheck = () =>
//   import(
//     /* webpackChunkName: "ServiceabilityCheck" */ '@/views/ServiceabilityCheck.vue'
//   );
// const BusinessRegistration = () =>
//   import(
//     /* webpackChunkName: "BusinessRegistration" */ '@/views/BusinessRegistration.vue'
//   );
const LinkAccounts = () =>
  import(
    /* webpackChunkName: "LinkAccounts" */ '@/views/LinkAccounts.vue'
  );
const LinkedAccounts = () =>
  import(
    /* webpackChunkName: "LinkedAccounts" */ '@/views/LinkedAccounts.vue'
  );
// const BusinessProfile = () =>
//   import(
//     /* webpackChunkName: "BusinessProfile" */ '@/views/BusinessProfile.vue'
//   );
// const PersonalProfileStep1 = () =>
//   import(
//     /* webpackChunkName: "PersonalProfileStep1" */ '@/views/PersonalProfileStep1.vue'
//   );
// const PersonalProfileStep2 = () =>
//   import(
//     /* webpackChunkName: "PersonalProfileStep2" */ '@/views/PersonalProfileStep2.vue'
//   );
const AdditionalInfo = () =>
  import(
    /* webpackChunkName: "AdditionalInfo" */ '@/views/AdditionalInfo.vue'
  );
// const ViewProfile = () =>
//   import(
//     /* webpackChunkName: "ViewProfile" */ '@/views/ViewProfile.vue'
//   );
const LoanOffers = () =>
  import(
    /* webpackChunkName: "LoanOffers" */ '@/views/LoanOffers.vue'
  );
const LoanAgreement = () =>
  import(
    /* webpackChunkName: "LoanAgreement" */ '@/views/LoanAgreement.vue'
  );
const LoanSuccess = () =>
  import(
    /* webpackChunkName: "LoanSuccess" */ '@/views/LoanSuccess.vue'
  );
const LoanFailure = () =>
  import(
    /* webpackChunkName: "LoanFailure" */ '@/views/LoanFailure.vue'
  );
const EMandateSuccess = () =>
  import(
    /* webpackChunkName: "EMandateSuccess" */ '@/views/EMandateSuccess.vue'
  );
const SignupUnderReview = () =>
  import(
    /* webpackChunkName: "SignupUnderReview" */ '@/views/SignupUnderReview.vue'
  );
const AdditionalDocuments = () =>
  import(
    /* webpackChunkName: "AdditionalDocuments" */ '@/views/AdditionalDocuments.vue'
  );
const DualNameDeclaration = () =>
  import(
    /* webpackChunkName: "DualNameDeclaration" */ '@/views/DualNameDeclaration.vue'
  );
const DualDobDeclaration = () =>
  import(
    /* webpackChunkName: "DualDobDeclaration" */ '@/views/DualDobDeclaration.vue'
  );
const BankDetails = () =>
  import(
    /* webpackChunkName: "BankDetails" */ '@/views/BankDetails.vue'
  );
const UploadDocuments = () =>
  import(
    /* webpackChunkName: "UploadDocuments" */ '@/views/UploadDocuments.vue'
  );
const Home = () =>
  import(
    /* webpackChunkName: "Home" */ '@/views/Home.vue'
  );
const MyProfile = () =>
  import(
    /* webpackChunkName: "MyProfile" */ '@/views/MyProfile.vue'
  );
const NachMandate = () =>
  import(
    /* webpackChunkName: "NachMandate" */ '@/views/NachMandate.vue'
  );
const UploadPreview = () =>
  import(
    /* webpackChunkName: "UploadPreview" */ '@/views/UploadPreview.vue'
  );
const Signup = () =>
  import(
    /* webpackChunkName: "Signup" */ '@/views/Signup.vue'
  );
const Mandate = () =>
  import(
    /* webpackChunkName: "Mandate" */ '@/views/Mandate.vue'
  );
const BankStatement = () =>
  import(
    /* webpackChunkName: "BankStatement" */ '@/views/BankStatement.vue'
  );
const Questionnaire = () =>
  import(
    /* webpackChunkName: "Questionnaire" */ '@/views/Questionnaire.vue'
  );
const PaymentHistory = () =>
  import(
    /* webpackChunkName: "PaymentHistory" */ '@/views/PaymentHistory.vue'
  );
const Rewards = () =>
  import(
    /* webpackChunkName: "Rewards" */ '@/views/Rewards.vue'
  );

const RewardStatement = () =>
  import(
    /* webpackChunkName: "RewardStatement" */ '@/views/RewardStatement.vue'
  );
const ReferAndEarn = () =>
  import(
    /* webpackChunkName: "ReferAndEarn" */ '@/views/ReferAndEarn.vue'
  );
const MyCards = () =>
  import(
    /* webpackChunkName: "MyCards" */ '@/views/MyCards.vue'
  );
const MandateSuccess = () =>
  import(
    /* webpackChunkName: "MandateSuccess" */ '@/views/MandateSuccess.vue'
  );
const MandateAlreadyCompleted = () =>
  import(
    /* webpackChunkName: "MandateAlreadyCompleted" */ '@/views/MandateAlreadyCompleted.vue'
  );
const NACHSuccess = () =>
  import(
    /* webpackChunkName: "NACHSuccess" */ '@/views/NACHSuccess.vue'
  );
const MandateFailure = () =>
  import(
    /* webpackChunkName: "MandateFailure" */ '@/views/MandateFailure.vue'
  );
const MandatePending = () =>
  import(
    /* webpackChunkName: "MandatePending" */ '@/views/MandatePending.vue'
  );
// const KycSelection = () =>
//   import(
//     /* webpackChunkName: "KycSelection" */ '@/views/KycSelection.vue'
//   );
// const Selfie = () =>
//   import(
//     /* webpackChunkName: "Selfie" */ '@/views/Selfie.vue'
//   );
const KycSuccess = () =>
  import(
    /* webpackChunkName: "KycSuccess" */ '@/views/KycSuccess.vue'
  );
const KycFailure = () =>
  import(
    /* webpackChunkName: "KycFailure" */ '@/views/KycFailure.vue'
  );
const KycResult = () =>
  import(
    /* webpackChunkName: "KycResult" */ '@/views/KycResult.vue'
  );
const LoanAutoActivation = () =>
  import(
    /* webpackChunkName: "LoanAutoActivation" */ '@/views/LoanAutoActivation.vue'
  );
const ApplicationDiscrepancy = () =>
  import(
    /* webpackChunkName: "ApplicationDiscrepancy" */ '@/views/ApplicationDiscrepancy.vue'
  );
const PayNow = () =>
  import(
    /* webpackChunkName: "PayNow" */ '@/views/PayNow.vue'
  );
const PaymentMethods = () =>
  import(
    /* webpackChunkName: "PaymentMethods" */ '@/views/PaymentMethods.vue'
  );
const VideoVerificationSuccess = () =>
  import(
    /* webpackChunkName: "VideoVerificationSuccess" */ '@/views/VideoVerificationSuccess.vue'
  );
const VideoVerificationFailure = () =>
  import(
    /* webpackChunkName: "VideoVerificationFailure" */ '@/views/VideoVerificationFailure.vue'
  );
const PaymentSuccess = () =>
  import(
    /* webpackChunkName: "PaymentSuccess" */ '@/views/PaymentSuccess.vue'
  );
const PaymentFailure = () =>
  import(
    /* webpackChunkName: "PaymentFailure" */ '@/views/PaymentFailure.vue'
  );
const TransactionSummary = () =>
  import(
    /* webpackChunkName: "TransactionSummary" */ '@/views/TransactionSummary.vue'
  );
// const ReferralInfo = () =>
//   import(
//     /* webpackChunkName: "ReferralInfo" */ '@/views/ReferralInfo.vue'
//   );
const VideoVerification = () =>
  import(
    /* webpackChunkName: "VideoVerification" */ '@/views/VideoVerification.vue'
  );
const CurrentAddress = () =>
    import(
      /* webpackChunkName: "CurrentAddress" */ '@/views/CurrentAddress.vue'
    );
const LoanDetails = () =>
  import(
    /* webpackChunkName: "LoanDetails" */ '@/views/LoanDetails.vue'
  );
const ErrorNotEligible = () =>
import(
  /* webpackChunkName: "ErrorNotEligible" */ '@/views/ErrorNotEligible.vue'
);
const TransactionDetails = () =>
  import(
    /* webpackChunkName: "TransactionDetails" */ '@/views/TransactionDetails.vue'
  );
const Suppliers = () =>
  import(
    /* webpackChunkName: "Suppliers" */ '@/views/Suppliers.vue'
  );
const Offers = () =>
  import(
    /* webpackChunkName: "Offers" */ '@/views/Offers.vue'
  );
const OfferDetails = () =>
  import(
    /* webpackChunkName: "OfferDetails" */ '@/views/OfferDetails.vue'
  );

const SupplierPaymentHistory = () =>
  import(
    /* webpackChunkName: "SupplierPaymentHistory" */ '@/views/SupplierPaymentHistory.vue'
  );
const SupplierPendingPayments = () =>
  import(
    /* webpackChunkName: "SupplierPendingPayments" */ '@/views/SupplierPendingPayments.vue'
  );
const SelectSupplier = () =>
  import(
    /* webpackChunkName: "SelectSupplier" */ '@/views/SelectSupplier.vue'
  );
const PendingRequests = () =>
  import(
    /* webpackChunkName: "PendingRequests" */ '@/views/PendingRequests.vue'
  );
const SupplierParent = () =>
  import(
    /* webpackChunkName: "SupplierParent" */ '@/views/SupplierParent.vue'
  );
const AddSupplier = () =>
  import(
    /* webpackChunkName: "AddSupplier" */ '@/views/AddSupplier.vue'
  );
const PendingPaymentDetails = () =>
  import(
    /* webpackChunkName: "PendingPaymentDetails" */ '@/views/PendingPaymentDetails.vue'
  );
const InviteSupplier = () =>
  import(
    /* webpackChunkName: "InviteSupplier" */ '@/views/InviteSupplier.vue'
  );
const SendInviteSupplier = () =>
  import(
    /* webpackChunkName: "SendInviteSupplier" */ '@/views/SendInviteSupplier.vue'
  );
const PrePostApprovalLayout = () =>
  import(
    /* webpackChunkName: "PrePostApprovalLayout" */ '@/views/PrePostApprovalLayout.vue'
  );
const PreApprovalStep1 = () =>
  import(
    /* webpackChunkName: "PreApprovalStep1" */ '@/views/PreApprovalStep1.vue'
  );
const PreApprovalStep2 = () =>
  import(
    /* webpackChunkName: "PreApprovalStep2" */ '@/views/PreApprovalStep2.vue'
  );
const PreApprovalStep3 = () =>
  import(
    /* webpackChunkName: "PreApprovalStep3" */ '@/views/PreApprovalStep3.vue'
  );
const PreApprovalKycSelection = () =>
  import(
    /* webpackChunkName: "PreApprovalKycSelection" */ '@/views/PreApprovalKycSelection.vue'
  );
const CreditOfferSelection = () =>
  import(
    /* webpackChunkName: "CreditOfferSelection" */ '@/views/CreditOfferSelection.vue'
  );
const PreApprovalReview = () =>
  import(
    /* webpackChunkName: "PreApprovalReview" */ '@/views/PreApprovalReview.vue'
  );
const PreApprovalCongratulations = () =>
  import(
    /* webpackChunkName: "PreApprovalCongratulations" */ '@/views/PreApprovalCongratulations.vue'
  );
const PreApprovalResult = () =>
  import(
    /* webpackChunkName: "PreApprovalResult" */ '@/views/PreApprovalResult.vue'
  );
const PostApprovalStep1 = () =>
  import(
    /* webpackChunkName: "PostApprovalStep1" */ '@/views/PostApprovalStep1.vue'
  );
const PostApprovalStep2 = () =>
  import(
    /* webpackChunkName: "PostApprovalStep2" */ '@/views/PostApprovalStep2.vue'
  );
const CreditStatement = () =>
  import(
    /* webpackChunkName: "CreditStatement" */ '@/views/CreditStatement.vue'
  );
const RewardSchemes = () =>
  import(
    /* webpackChunkName: "RewardSchemes" */ '@/views/RewardSchemes.vue'
  );
const RewardSchemeDetails = () =>
  import(
    /* webpackChunkName: "RewardSchemeDetails" */ '@/views/RewardSchemeDetails.vue'
  );
const downloadStatement = () =>
  import(
    /* webpackChunkName: "downloadStatement" */ '@/views/downloadStatement.vue'
  );
const BankTransfers = () =>
  import(
    /* webpackChunkName: "BankTransfers" */ '@/views/BankTransfers.vue'
  );
const LoanAgreementDocument = () =>
  import(
    /* webpackChunkName: "LoanAgreementDocument" */ '@/views/LoanAgreementDocument.vue'
  );
const DocumentsData = () =>
  import(
    /* webpackChunkName: "DocumentsData" */ '@/views/DocumentsData.vue'
  );
const DocumentUpload = () =>
  import(
    /* webpackChunkName: "DocumentUpload" */ '@/views/KycDetails/DocumentUpload.vue'
  );
const PaymentOptions = () =>
  import(
    /* webpackChunkName: "PaymentOptions" */ '@/views/PaymentOptions.vue'
  );
const PartialPayment = () =>
  import(
    /* webpackChunkName: "PartialPayment" */ '@/views/PartialPayment.vue'
  );
const NetBanking = () =>
  import(
    /* webpackChunkName: "NetBanking" */ '@/views/NetBanking.vue'
  );
const DebitCard = () =>
  import(
    /* webpackChunkName: "DebitCard" */ '@/views/DebitCard.vue'
  );
const SuppliersDetails = () =>
  import(
    /* webpackChunkName: "SuppliersDetails" */ '@/views/SupplierDetails.vue'
  );
const TransactionNotEligible = () =>
  import(
    /* webpackChunkName: "TransactionNotEligible" */ '@/views/TransactionNotEligible.vue'
  );
const UploadInvoice = () =>
  import(
    /* webpackChunkName: "UploadInvoice" */ '@/views/UploadInvoice.vue'
  );
const QuickPayment = () =>
  import(
      /* webpackChunkName: "QuickPayment" */ '@/views/QuickPayment.vue'
  );
const BillProcessed = () =>
  import(
      /* webpackChunkName: "BillProcessed" */ '@/views/BillProcessed.vue'
  );
const SupplierSettledBills = () =>
  import(
      /* webpackChunkName: "SupplierSettledBills" */ '@/views/SupplierSettledBills.vue'
  );
const OpenCameraStorePhoto = () =>
  import(
      /* webpackChunkName: "OpenCameraStorePhoto" */ '@/views/OpenCameraStorePhoto.vue'
  );
const PreviewStatements = () =>
  import(
      /* webpackChunkName: "PreviewStatements" */ '@/views/PreviewStatements.vue'
  );
const ApplicationRejected = () =>
  import(
      /* webpackChunkName: "ApplicationRejected" */ '@/views/ApplicationRejected.vue'
  );
const BackToGPay = () =>
  import(
      /* webpackChunkName: "BackToGPay" */ '@/views/BackToGPay.vue'
  );
const WebView = () =>
  import(
      /* webpackChunkName: "WebView" */ '@/views/WebView.vue'
  );
const Support = () =>
  import(
      /* webpackChunkName: "Support" */ '@/views/Support.vue'
  );
const InviteSuppliers = () =>
  import(
      /* webpackChunkName: "InviteSuppliers" */ '@/views/Invite/InviteSuppliers.vue'
  );
const InviteNewSuppliers = () =>
  import(
      /* webpackChunkName: "InviteNewSuppliers" */ '@/views/Invite/InviteNewSuppliers.vue'
  );
const ShareContent = () =>
  import(
      /* webpackChunkName: "Share" */ '@/views/Invite/ShareContent.vue'
  );

const AadharEsignResult = () =>
  import(
      /* webpackChunkName: "Share" */ '@/views/AadharEsignResult.vue'
  );
const ShowBankStatement = () =>
  import(
      /* webpackChunkName: "Share" */ '@/views/ShowBankStatement.vue'
  );
const OtherGstAdd = () =>
  import(
    /* webpackChunkName: "otherGstAdd" */ '@/views/otherGstAdd.vue'
  );
const ProductCards = () =>
  import(
    /* webpackChunkName: "ProductCards" */ '@/views/ProductCards.vue'
  );
const UdyamVerificationAdd = () =>
  import(
    /* webpackChunkName: "UdyamVerificationAdd" */ '@/views/UdyamVerificationAdd.vue'
  );
const OneMoneyToEpl = () =>
  import(
    /* webpackChunkName: "OneMoneyToEpl" */ '@/views/OneMoneyToEpl.vue'
  );
// const EdiBankStatement = () =>
//   import(
//     /* webpackChunkName: "EdiBankStatement" */ '@/views/EdiBankStatement.vue'
//   );

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: '',
        redirect: { name: 'Mobile No' }
      },
      {
        name: 'Mobile No',
        path: 'mobile-no',
        component: MobileNo,
        meta: {
          requiresAuth: false
        },
        props: true
      },
      {
        path: 'verify-otp',
        name: 'Verify Otp',
        component: VerifyOtp,
        meta: {
          requiresAuth: false
        }
      },
    ]
  },
  {
    path: '/aadhaar-esign-success',
    name: 'AadharEsignResult',
    component: AadharEsignResult,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      requiresAuth: true
    },
    children: [
      // {
      //   path: 'tnc',
      //   name: 'Tnc',
      //   component: Tnc,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Terms & Conditions',
      //     allowedStatus: ['initiated'],
      //     transitionName: 'slide'
      //   }
      // },
      {
        path: 'pre-approval',
        name: 'Pre Approval',
        component: PrePostApprovalLayout,
        meta: {
          requiresAuth: true,
          displayName: 'Pre Approval',
          transitionName: 'slide',
          allowedStatus: ['initiated'],
        },
        children: [
          {
            path: '',
            redirect: { name: 'Pre Approval Step 1' }
          },
          {
            name: 'Pre Approval Step 1',
            path: 'step-1',
            component: PreApprovalStep1,
            meta: {
              requiresAuth: true,
              displayName: 'Details',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 1,
              showRewardsBanner: true
            }
          },
          {
            name: 'Edit Pre Approval Step 1',
            path: 'edit/step-1',
            component: PreApprovalStep1,
            meta: {
              requiresAuth: true,
              displayName: 'Personal Details',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              isEdit: true
            }
          },
          {
            name: 'Credit Offer Selection',
            path: 'credit-offer',
            component: CreditOfferSelection,
            meta: {
              requiresAuth: true,
              displayName: 'Credit Offer',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 2,
              showRewardsBanner: true
            }
          },
          {
            name: 'Pre Approval KYC Selection',
            path: 'kyc',
            component: PreApprovalKycSelection,
            meta: {
              requiresAuth: true,
              displayName: 'KYC',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 3,
              showRewardsBanner: true,
              showBackArrow: false,
              redirectBackTo: ''
            }
          },
          {
            name: 'Pre Approval Step 2',
            path: 'kyc-details',
            component: PreApprovalStep2,
            meta: {
              requiresAuth: true,
              displayName: 'KYC',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              showRewardsBanner: true,
              showBackArrow: true,
              redirectBackTo: 'Pre Approval KYC Selection'
            },
          },
          {
            path: 'other-gst-add',
            name: 'Other Gst Add',
            component: OtherGstAdd,
            meta: {
              requiresAuth: true,
              allowedStatus: ['tncAccepted', 'initiated'],
              transitionName: 'slide',
              displayName: 'GSTIN',
              showBackArrow: true,
              redirectBackTo: 'Pre Approval Step 1'
            },
          },
          {
            name: 'Product Card',
            path: 'product-card',
            component: ProductCards,
            meta: {
              requiresAuth: true,
              displayName: 'Products',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 3,
              showRewardsBanner: true,
              redirectBackTo: ''
            }
          },
          {
            name: 'Document Upload',
            path: 'document-upload/:name',
            component: DocumentUpload,
            meta: {
              requiresAuth: true,
              displayName: '',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              showBackArrow: true,
              redirectBackTo: 'Pre Approval Step 2'
            }
          },
          {
            name: 'Edit Pre Approval Step 2',
            path: 'edit/step-2',
            component: PreApprovalStep2,
            meta: {
              requiresAuth: true,
              displayName: 'KYC',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              isEdit: true
            }
          },
          {
            path: 'video-verification',
            name: 'Video Verification',
            component: VideoVerification,
            meta: {
              requiresAuth: true,
              displayName: 'Video Verification',
              allowedStatus: ['offerSelected'],
              transitionName: 'slide',
              showRewardsBanner: true
            },
          },
          {
            path: 'current-address',
            name: 'Current Address',
            component: CurrentAddress,
            meta: {
              requiresAuth: true,
              displayName: 'Personal Address',
              allowedStatus: ['offerSelected'],
              transitionName: 'slide',
              showRewardsBanner: true
            },
          },
          {
            name: 'Pre Approval Step 3',
            path: 'step-3',
            component: PreApprovalStep3,
            meta: {
              requiresAuth: true,
              displayName: 'Business Verification',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 3,
              showRewardsBanner: true
            },
            children: [
              {
                name: 'Open Camera Store Photo',
                path: 'open-camera-store-photo',
                component: OpenCameraStorePhoto,
                meta: {
                  requiresAuth: true,
                  transitionName: 'slide',
                  allowedStatus: ['initiated'],
                  showSidebar: true
                }
              },
            ]
          },
          {
            path: 'business-verification/other-gst-add',
            name: 'Other Gst Add Business Verification',
            component: OtherGstAdd,
            meta: {
              requiresAuth: true,
              allowedStatus: ['tncAccepted', 'initiated'],
              transitionName: 'slide',
              displayName: 'GSTIN',
              showBackArrow: true,
              showSidebar: true,
              redirectBackTo: 'Pre Approval Step 3'
            },
          },
          {
            path: 'udyam-verification',
            name: 'Udyam Verification Add',
            component: UdyamVerificationAdd,
            meta: {
              requiresAuth: true,
              allowedStatus: ['tncAccepted', 'initiated'],
              transitionName: 'slide',
              displayName: 'Udyam',
              showBackArrow: true,
              showSidebar: true,
              redirectBackTo: 'Pre Approval Step 3'
            },
          },
          {
            name: 'Show Bank Statement',
            path: 'show-bank-statement',
            component: ShowBankStatement,
            meta: {
              requiresAuth: true,
              displayName: 'Uploaded Files',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              showRewardsBanner: true,
            },
            children: [
              {
                name: 'Preview Statements',
                path: 'preview-statements',
                component: PreviewStatements,
                meta: {
                  requiresAuth: true,
                  transitionName: 'slide',
                  allowedStatus: ['initiated'],
                  showSidebar: true
                }
              },
            ],
          },
          {
            name: 'Edit Pre Approval Step 3',
            path: 'edit/step-3',
            component: PreApprovalStep3,
            meta: {
              requiresAuth: true,
              displayName: 'Business Profile',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              isEdit: true
            }
          },
          {
            name: 'Pre Approval Review',
            path: 'review',
            component: PreApprovalReview,
            meta: {
              requiresAuth: true,
              displayName: 'Review Application',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
            }
          },
          {
            path: 'loan-agreement',
            name: 'Loan Agreement',
            component: LoanAgreement,
            meta: {
              requiresAuth: true,
              displayName: 'Loan Documents',
              allowedStatus: ['nachUploaded', 'readyForOps', 'opsApproved', 'emandatePending'],
              transitionName: 'slide',
              showRewardsBanner: true
            }
          },
        ]
      },
      {
        path: 'post-approval',
        name: 'Post Approval',
        component: PrePostApprovalLayout,
        meta: {
          requiresAuth: true,
          displayName: 'Post Approval',
          transitionName: 'slide',
          allowedStatus: ['initiated'],
        },
        children: [
          {
            path: '',
            redirect: { name: 'Post Approval Step 1' }
          },
          {
            name: 'Post Approval Step 1',
            path: 'step-1',
            component: PostApprovalStep1,
            meta: {
              requiresAuth: true,
              displayName: 'Mandate',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 4,
              showRewardsBanner: true
            }
          },
          {
            name: 'Post Approval Step 2',
            path: 'step-2',
            component: PostApprovalStep2,
            meta: {
              requiresAuth: true,
              displayName: 'NACH Mandate',
              transitionName: 'slide',
              allowedStatus: ['initiated', 'readyForOps'],
              totalSteps: 4,
              currentStep: 4,
              showRewardsBanner: true,
              showBackArrow: true,
              redirectBackTo: 'Post Approval Step 1'
            },
            children: [
              {
                path: 'nach-success',
                name: 'NACH Success',
                component: NACHSuccess,
                meta: {
                  requiresAuth: true,
                  displayName: '',
                  allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
                  transitionName: 'slide'
                },
              },

            ]
          },
          {
            path: 'edi-bank-statement',
            name: 'Edi Bank Statement',
            component: PostApprovalStep1,
            meta: {
              requiresAuth: false,
              displayName: 'Mandate',
              transitionName: 'slide',
              allowedStatus: ['initiated'],
              totalSteps: 4,
              currentStep: 4,
              showRewardsBanner: true
            },
          },
        ]
      },
      {
        name: 'Pre Approval Result',
        path: 'result',
        component: PreApprovalResult,
        meta: {
          requiresAuth: true,
          displayName: '',
          transitionName: 'slide',
          allowedStatus: ['initiated'],
        }
      },
      {
        name: 'Pre Approval Congratulations',
        path: 'congratulations',
        component: PreApprovalCongratulations,
        meta: {
          requiresAuth: true,
          displayName: '',
          transitionName: 'slide',
          allowedStatus: ['initiated'],
        }
      },
      {
        path: ':action/link-accounts',
        name: 'Link Accounts',
        component: LinkAccounts,
        meta: {
          requiresAuth: true,
          displayName: 'Link Supplier Account',
          allowedStatus: ['marketplaceDocumentUploadInProgress', 'opsApproved', 'readyForOps', 'approved',
            'nachUploaded',
            'nbfcApproved',
            'offerSelected',
            'bankDetailsUpdated',
            'chequeUploaded',
            'documentUploadInProgress',
            'documentUploaded',
            'emandatePending',
            'nachDownloaded', 'videoVerified'],
          transitionName: 'slide'
        }
      },
      {
        path: 'linked-accounts',
        name: 'Linked Accounts',
        component: LinkedAccounts,
        meta: {
          requiresAuth: true,
          displayName: 'Linked Suppliers',
          allowedStatus: ['marketplaceDocumentUploadInProgress', 'opsApproved', 'readyForOps', 'approved',
            'nachUploaded',
            'nbfcApproved',
            'offerSelected',
            'bankDetailsUpdated',
            'chequeUploaded',
            'documentUploadInProgress',
            'documentUploaded',
            'emandatePending',
            'nachDownloaded',
          ],
          transitionName: 'slide'
        }
      },
      {
        path: 'additional-info',
        name: 'Additional Info',
        component: AdditionalInfo,
        meta: {
          requiresAuth: true,
          displayName: 'GSTIN Verification',
          allowedStatus: [
            "initiated",
            "tncAccepted",
            "fosSkipped",
            "fosAssigned",
            "addressProofAsPerIdUploaded",
            "addressProofIdNumberUpdated",
            "personalInfoUpdated",
            "businessRegistrationDetailsUpdated",
            "businessInfoUpdated",
            "marketplaceDocumentUploadInProgress",
            "marketplaceDocumentUploaded",
            "croReview",
            "bankDetailsUpdated",
            "emandatePending",
            "bankStatementUploaded",
            "documentUploaded",
            "approved",
            "videoVerified",
            "offerSelected",
            "documentUploadInProgress",
            "questionnairePending",
            "questionnaireSubmitted",
            "nachUploaded",
            "nachDownloaded",
            "nbfcApproved",
            "opsApproved",
            "readyForOps",
            "selfieUploaded",
            "bankStatementSkipped",
            "manualBankStatementUploaded",
            "businessRegistrationDetailsSkipped",
            "digiLockerVerified",
            "chequeUploaded",
            "serviceabilityChecked"
          ],
          transitionName: 'slide'
        }
      },
      // {
      //   path: 'view-profile',
      //   name: 'View Profile',
      //   component: ViewProfile,
      //   meta: {
      //     requiresAuth: true,
      //     displayName: 'Review Application',
      //     allowedStatus: ['marketplaceDocumentUploaded', 'bankStatementSkipped'],
      //     transitionName: 'slide'
      //   },
      // },
      {
        path: 'bank-details',
        name: 'Bank Details',
        component: BankDetails,
        meta: {
          requiresAuth: true,
          displayName: 'Bank Details',
          allowedStatus: ['chequeUploaded', 'readyForOps',
            'opsApproved', 'offerSelected'
          ],
          transitionName: 'slide'
        }
      },
      {
        path: 'upload-documents',
        name: 'Upload Documents',
        component: UploadDocuments,
        meta: {
          requiresAuth: true,
          displayName: 'Upload Documents',
          allowedStatus: ['bankDetailsUpdated', 'documentUploadInProgress', 'readyForOps', 'opsApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'additional-documents',
        name: 'Additional Documents',
        component: AdditionalDocuments,
        meta: {
          requiresAuth: true,
          displayName: 'Additional Documents',
          allowedStatus: ['documentUploadInProgress', 'readyForOps', 'bankDetailsUpdated', 'opsApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'dual-name-declaration',
        name: 'Dual Name Declaration',
        component: DualNameDeclaration,
        meta: {
          requiresAuth: true,
          displayName: 'Dual Name Declaration',
          allowedStatus: ['bankDetailsUpdated', 'documentUploadInProgress', 'readyForOps', 'opsApproved'],
          transitionName: 'slide'

        }
      },
      {
        path: 'dual-dob-declaration',
        name: 'Dual Dob Declaration',
        component: DualDobDeclaration,
        meta: {
          requiresAuth: true,
          displayName: 'Dual Dob Declaration',
          allowedStatus: ['bankDetailsUpdated', 'documentUploadInProgress', 'readyForOps', 'opsApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'mandate',
        name: 'Mandate',
        component: Mandate,
        meta: {
          requiresAuth: true,
          displayName: 'NACH / eMandate',
          allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        },
      },
      {
        path: 'mandate/success',
        name: 'Mandate Success',
        component: MandateSuccess,
        meta: {
          requiresAuth: true,
          displayName: '',
          allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved', 'businessInfoUpdated'],
          transitionName: 'slide'
        },
      },
      {
        path: 'nach-mandate',
        name: 'NACH Mandate',
        component: NachMandate,
        meta: {
          requiresAuth: true,
          displayName: 'NACH Mandate',
          allowedStatus: ['emandatePending', 'nachDownloaded', 'emandateRegistered', 'emandateFailed', 'documentUploaded', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'bank-statement',
        name: 'Bank Statement',
        component: BankStatement,
        meta: {
          requiresAuth: true,
          displayName: 'Bank Statement',
          allowedStatus: ['marketplaceDocumentUploaded', 'opsApproved', 'approved', 'readyForOps', 'opsApproved', 'nbfcApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'questionnaire',
        name: 'Questionnaire',
        component: Questionnaire,
        meta: {
          requiresAuth: true,
          displayName: 'Questionnaire',
          allowedStatus: ['questionnairePending'],
          transitionName: 'slide'
        }
      },
      {
        path: 'success',
        name: 'Signup Success',
        component: Success,
        meta: {
          requiresAuth: true,
          displayName: undefined,
          allowedStatus: ['approved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'loan-success',
        name: 'Loan Success',
        component: LoanSuccess,
        meta: {
          requiresAuth: true,
          allowedStatus: ['readyForOps', 'opsApproved'],
          transitionName: 'slide'
        }
      },
      {
        path: 'loan-activated',
        name: 'Loan Auto Activation',
        component: LoanAutoActivation,
        meta: {
          requiresAuth: true,
          allowedStatus: [],
          transitionName: 'slide'
        }
      },
      {
        path: 'failure',
        name: 'Signup Failure',
        component: Failure,
        meta: {
          requiresAuth: false,
          transitionName: 'slide'
        }
      },
      {
        path: 'kyc-result',
        name: 'KYC Result',
        component: KycResult,
        meta: {
          requiresAuth: true,
          allowedStatus: ['fosSkipped', 'serviceabilityChecked', 'addressProofAsPerIdUploaded', 'digiLockerVerified', 'personalInfoUpdated'],
          transitionName: 'slide'
        }
      },
      {
        path: 'discrepancy',
        name: 'Application Discrepancy',
        component: ApplicationDiscrepancy,
        meta: {
          requiresAuth: true,
          allowedStatus: ['readyForOps'],
          transitionName: 'slide',
          displayName: 'Application Discrepancy',
        },
      },
    ]
  },
  {
    path: '',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true,
          displayName: 'Dashboard'
        },
        children: [
          {
            path: 'details',
            name: 'Home Offer Details',
            component: OfferDetails,
            meta: {
              requiresAuth: true,
              displayName: 'Offer Details',
              showSidebar: true
            }
          },
          {
            path: 'pay-now',
            name: 'Pay Now',
            component: PayNow,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Pay Now'

            },
          },
          {
            path: 'transaction-details',
            name: 'Transaction Details',
            component: TransactionDetails,
            meta: {
              requiresAuth: true,
              showSidebar: true,
              displayName: 'Transaction Details'

            },
          },
          {
            path: 'transaction-summary',
            name: 'Transaction Summary',
            component: TransactionSummary,
            meta: {
              requiresAuth: true,
              showSidebar: true
            },
          },
        ]
      },
      {
        path: '/loan-offers',
        name: 'Loan Offers',
        component: LoanOffers,
        meta: {
          requiresAuth: true,
          displayName: 'Loan Offers'

        }
      },
      {
        path: '/supplier/:id?',
        component: SupplierParent,
        children: [
          {
            path: 'payment-history',
            name: 'Supplier Payment History',
            component: SupplierPaymentHistory,
            meta: {
              requiresAuth: true,
              displayName: 'Payment History'
            },
            children: [
              {
                path: 'payment-methods',
                name: 'Supplier Payment Methods',
                component: PaymentMethods,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Make Payment',
                  isSupplierFlow: true
                },
              },
              {
                path: 'pay-now',
                name: 'Supplier Pay Now',
                component: PayNow,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Pay Now',
                  isSupplierFlow: true

                },
              },
              {
                path: 'transaction-details',
                name: 'Supplier Transaction Details',
                component: TransactionDetails,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Transaction Details',
                  isSupplierFlow: true
                },
              },
              {
                path: 'transaction-summary',
                name: 'Supplier Transaction Summary',
                component: TransactionSummary,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  isSupplierFlow: true
                },
              },
            ]
          },
          {
            path: 'pending-payments',
            name: 'Supplier Pending Payments',
            component: SupplierPendingPayments,
            meta: {
              requiresAuth: true,
              displayName: 'Pending Payments'
            },
            children: [
              {
                path: 'details',
                name: 'Pending Payment Details',
                component: PendingPaymentDetails,
                meta: {
                  requiresAuth: true,
                  showSidebar: true,
                  displayName: 'Transaction Details',
                  isSupplierFlow: true
                },
              }]
          },
          {
            path: 'select',
            name: 'Select Supplier',
            component: SelectSupplier,
            meta: {
              requiresAuth: true,
              displayName: 'Select Supplier'
            },
            children: [
              {
                path: 'add',
                name: 'Add Supplier',
                component: AddSupplier,
                meta: {
                  requiresAuth: true,
                  displayName: 'Add Supplier'
                }
              },
              {
                path: 'invite',
                name: 'Invite Supplier',
                component: InviteSupplier,
                meta: {
                  requiresAuth: true,
                  displayName: 'Invite Supplier'
                }
              },
              {
                path: 'send-invite',
                name: 'Send Invite Supplier',
                component: SendInviteSupplier,
                meta: {
                  requiresAuth: true,
                  displayName: 'Invite Supplier'
                }
              },
            ]
          },
          {
            path: 'pending-requests',
            name: 'Pending Requests',
            component: PendingRequests,
            meta: {
              requiresAuth: true,
              displayName: 'Pending Requests'
            }
          },
        ]
      },
      {
        path: '/offers',
        name: 'Offers',
        component: Offers,
        meta: {
          requiresAuth: true,
          displayName: 'Offers'
        },
        children: [
          {
            path: 'details',
            name: 'Offer Details',
            component: OfferDetails,
            meta: {
              requiresAuth: true,
              displayName: 'Offer Details'
            }
          },
        ]
      },
      {
        path: '/my-profile',
        name: 'My Profile',
        component: MyProfile,
        meta: {
          requiresAuth: true,
          displayName: 'My Profile'
        },
      },
      {
        path: 'bank-transfers',
        name: 'BankTransfers',
        component: BankTransfers,
        meta: {
          requiresAuth: true,
          displayName: 'A/C details for bank transfers',
          transitionName: 'slide'
        },
      },
      {
        path: 'loan-agreement/document',
        name: 'Loan Agreement Document',
        component: LoanAgreementDocument,
        meta: {
          requiresAuth: true,
          displayName: 'Loan Agreement(s)',
          transitionName: 'slide'
        },
      },
      {
        path: 'documents',
        name: 'Documents Data',
        component: DocumentsData,
        meta: {
          requiresAuth: true,
          displayName: 'Documents',
          transitionName: 'slide'
        },
        redirect: {
          name: 'My Profile Documents'
        },
        children: [
          {
            name: 'My Profile Documents',
            path: '',
            component: UploadDocuments,
            meta: {
              requiresAuth: true,
              displayName: 'My Profile'
            },
          }
        ]
      },
      {
        path: '/payment-history',
        name: 'Payment History',
        component: PaymentHistory,
        meta: {
          requiresAuth: true,
          displayName: 'Payment History'
        },

      },
      {
        path: '/rewards',
        name: 'Rewards',
        component: Rewards,
        meta: {
          requiresAuth: true,
          displayName: 'Rewards'
        },
        redirect: {
          name: 'Reward Statement',
        },
        children: [
          {
            path: 'statement',
            name: 'Reward Statement',
            component: RewardStatement,
            meta: {
              requiresAuth: true,
              displayName: 'Reward Statement'
            }
          },
          {
            path: 'schemes',
            name: 'Reward Schemes',
            component: RewardSchemes,
            meta: {
              requiresAuth: true,
              displayName: 'Reward Schemes'
            },
            children: [
              {
                path: ':id',
                name: 'Reward Scheme Details',
                component: RewardSchemeDetails,
                meta: {
                  requiresAuth: true,
                  displayName: 'Reward Scheme Details',
                  showSidebar: true
                }
              }
            ]
          }
        ]
      },
      {
        path: '/refer-and-earn',
        name: 'Refer And Earn',
        component: ReferAndEarn,
        meta: {
          requiresAuth: true,
          displayName: 'Refer And Earn'

        }
      },
      {
        path: '/cards',
        name: 'My Cards',
        component: MyCards,
        meta: {
          requiresAuth: true,
          displayName: 'My Cards'

        }
      },
      // {
      //   path: '/help',
      //   name: 'Help',
      //   meta: {
      //     requiresAuth: true,
      //   },
      //   beforeEnter: () => {
      //     window.location.href = 'https://epaylater.in/support.html';
      //   }
      // },
    ]
  },
  {
    path: '/credit-statement',
    name: 'Credit Statement',
    component: CreditStatement,
    meta: {
      requiresAuth: true,
      displayName: 'Credit Statement'
    },
    children: [
      {
        path: 'transaction-details',
        name: 'Credit Statement Transaction Details',
        component: TransactionDetails,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          displayName: 'Settled Bill',
          isCreditStatementFlow: true
        },
      },
      {
        path: 'transaction-summary',
        name: 'Credit Statement Transaction Summary',
        component: TransactionSummary,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          isCreditStatementFlow: true
        },
      },
      {
        path: 'download-statement',
        name: 'Credit Statement download statement',
        component: downloadStatement,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          displayName: 'Download Statement',
          isCreditStatementFlow: true
        },
      },
    ]

  },
  {
    path: '/make-payment',
    name: 'Credit Statement Pay Now',
    component: PayNow,
    meta: {
      requiresAuth: true,
      displayName: 'Make Payment',
    },
    children: [
      {
        path: 'payment-methods',
        name: 'Payment Methods',
        component: PaymentMethods,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          displayName: ''
        },
      },
      {
        path: 'partial-payment',
        name: 'Partial Payment',
        component: PartialPayment,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          displayName: ''
        },
      },
    ]
  },
  {
    path: '/payment-options',
    name: 'Payment Options',
    component: PaymentOptions,
    meta: {
      requiresAuth: true,
      displayName: 'Payment Options',
    }
  },
  {
    path: '/net-banking',
    name: 'NetBanking',
    component: NetBanking,
    meta: {
      requiresAuth: true,
      displayName: '',
    }
  },
  {
    path: '/debit-card',
    name: 'Debit Card',
    component: DebitCard,
    meta: {
      requiresAuth: true,
      displayName: '',
    }
  },
  {
    path: '/loan-failure',
    name: 'Loan Failure',
    component: LoanFailure,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mandate/success',
    name: 'EMandate Success',
    component: EMandateSuccess,
    meta: {
      requiresAuth: false,
      displayName: '',
    },
  },
  {
    path: '/mandate/failure',
    name: 'Mandate Failure',
    component: MandateFailure,
    meta: {
      requiresAuth: false,
      displayName: '',
    },
  },
  {
    path: '/mandate/pending',
    name: 'Mandate Pending',
    component: MandatePending,
    meta: {
      requiresAuth: false,
      displayName: '',
    },
  },
  {
    path: '/mandate/completed',
    name: 'Mandate Already Completed',
    component: MandateAlreadyCompleted,
    meta: {
      requiresAuth: false,
      displayName: '',
    },
  },
  {
    path: '/suppliers',
    name: 'Suppliers',
    component: Suppliers,
    meta: {
      requiresAuth: true,
      displayName: 'Suppliers'
    },
  },
  {
    path: '/supplier-Settled-Bills',
    name: 'Supplier Settled Bills',
    component: SupplierSettledBills,
    meta: {
      requiresAuth: true,
      displayName: 'Settled Bills'
    },
  },
  {
    path: '/application-rejected',
    name: 'Application Rejected',
    component: ApplicationRejected,
    meta: {
      requiresAuth: true,
      displayName: ''
    },
  },
  {
    path: '/suppliers-details',
    name: 'Suppliers Details',
    component: SuppliersDetails,
    meta: {
      requiresAuth: true,
      displayName: ''
    },
    children: [
      {
        path: 'transaction-not-eligible',
        name: 'Transaction Not Eligible',
        component: TransactionNotEligible,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          displayName: ''
        },
      },
      {
        path: 'upload-invoice',
        name: 'Upload Invoice',
        component: UploadInvoice,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          displayName: ''
        },
      },
    ]
  },
  {
    path: '/quick-payment',
    name: 'Quick Payment',
    component: QuickPayment,
    meta: {
      requiresAuth: true,
      displayName: ''
    },
    children: [
      {
        path: 'transaction-not-eligible',
        name: 'Quick Transaction Not Eligible',
        component: TransactionNotEligible,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          displayName: ''
        },
      },
    ]
  },
  {
    path: '/bill-processed',
    name: 'Bill Processed',
    component: BillProcessed,
    meta: {
      requiresAuth: true,
      displayName: ''
    },
  },
  {
    path: '/video-verification-success',
    name: 'Video Verification Success',
    component: VideoVerificationSuccess,
    meta: {
      requiresAuth: false,
      displayName: ''
    },
  },
  {
    path: '/video-verification-failure',
    name: 'Video Verification Failure',
    component: VideoVerificationFailure,
    meta: {
      requiresAuth: false,
      displayName: ''
    },
  },
  {
    path: '/one-money-to-epl',
    name: 'One Money To Epl',
    component: OneMoneyToEpl,
    meta: {
      requiresAuth: false,
      displayName: ''
    },
  },
  {
    path: '/payment-success',
    name: 'Payment Success',
    component: PaymentSuccess,
    meta: {
      requiresAuth: false,
      displayName: 'Payment Success'
    },
  },
  {
    path: '/payment-failure',
    name: 'Payment Failure',
    component: PaymentFailure,
    meta: {
      requiresAuth: false,
      displayName: 'Payment Failure'
    },
  },
  {
    path: '/kyc-failure',
    name: 'KYC Failure',
    component: KycFailure,
    meta: {
      requiresAuth: false,
      allowedStatus: ['fosSkipped', 'serviceabilityChecked', 'addressProofAsPerIdUploaded', 'digiLockerVerified', 'personalInfoUpdated'],
      transitionName: 'slide'
    }
  },
  {
    path: '/kyc-success',
    name: 'KYC Success',
    component: KycSuccess,
    meta: {
      requiresAuth: false,
      allowedStatus: ['fosSkipped', 'serviceabilityChecked', 'addressProofAsPerIdUploaded', 'digiLockerVerified', 'personalInfoUpdated'],
    }
  },
  {
    path: '/invite-suppliers',
    name: 'Invite Suppliers',
    component: InviteSuppliers,
    meta: {
      requiresAuth: true,
      displayName: ''
    },
    children: [
      {
        path: 'share',
        name: 'Share Content',
        component: ShareContent,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          displayName: ''
        },
      },
    ]
  },
  {
    path: '/invite-new-suppliers',
    name: 'Invite New Suppliers',
    component: InviteNewSuppliers,
    meta: {
      requiresAuth: true,
      displayName: ''
    },
    children: [
      {
        path: 'share',
        name: 'Share New Suppliers',
        component: ShareContent,
        meta: {
          requiresAuth: true,
          showSidebar: true,
          displayName: ''
        },
      },
    ]
  },
  {
    path: '/support',
    name: 'Support',
    component: Support,
    meta: {
      requiresAuth: true,
      displayName: 'Support'
    },
  },
  {
    path: '/webview',
    name: 'Web View',
    component: WebView,
    meta: {
      requiresAuth: false,
      displayName: ''
    },
  },
  {
    path: '/back-to-gPay',
    name: 'Back To GPay',
    component: BackToGPay,
    meta: {
      requiresAuth: false,
      displayName: ''
    },
  },
  {
    path: '/:id/signup-under-review',
    name: 'Signup Under Review',
    component: SignupUnderReview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/:documentName/upload-preview',
    name: 'Upload Preview',
    component: UploadPreview,
    meta: {
      requiresAuth: true,
      allowedStatus: ['bankDetailsUpdated', 'documentUploadInProgress', 'readyForOps', 'opsApproved']
    }
  },
  {
    path: '/:nbfcName/loan-details',
    name: 'Loan Details',
    component: LoanDetails,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/error-not-eligible',
    name: 'ErrorNotEligible',
    component: ErrorNotEligible,
    meta: {
      requiresAuth: false,
    },
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  store.commit('Micro_Apps_Url_Params', to?.query);
  const isAuthenticated = localStorage.getItem('token') && /^[6-9][0-9]{9}/.test(localStorage.getItem('phone'));
  const isReferralFlow = JSON.parse(localStorage.getItem('isReferralFlow'));
  if (to.meta.requiresAuth && !isAuthenticated && typeof GenericEpaylater === 'undefined') {
    if (to?.query.redirect === 'on-boarding' ||
      to?.query.redirect === 'suppliers' ||
      to?.query.redirect === 'transaction-list' ||
      to?.query.redirect === 'transaction-details' ||
      to?.query.redirect === 'on-boarding-testing' ||
      to?.query.redirect === 'suppliers-testing' ||
      to?.query.redirect === 'transaction-details-testing' ||
      to?.query.redirect === 'transaction-list-testing'
    ) {
      next({ name: 'Mobile No', query: { redirect: to.name, ...to.query } });
    } else {
      next({ name: 'Back To GPay', query: { message: 'Something went wrong please try again!' } });
    }
  } else if (typeof GenericEpaylater !== 'undefined') {
    // eslint-disable-next-line no-undef
    const android = GenericEpaylater || undefined;
    localStorage.setItem('token', android.userToken());
    localStorage.setItem('phone', android.userPhone());
    next();
  } else if ((to.name === 'Mobile No' || to.name === 'Verify Otp') && isAuthenticated && isReferralFlow) {
    const urlParams = JSON.parse(localStorage.getItem("getURIParameter"));
    localStorage.setItem("newUrl", urlParams.href);
    store.dispatch('customerLogout');
  } else next();
});
export default router;
